import React from 'react';
import DOMPurify from 'dompurify';
import PopLayer from './components/popLayer';
import './speakerModal.scss';

class SafeHtmlPreview extends React.Component {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
    }
    componentDidMount() {
        if (this.containerRef.current) {
            this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.html !== this.props.html && this.containerRef.current) {
            this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
        }
    }
    render() {
        return <div className={this.props.className} ref={this.containerRef} />;
    }
}

export default class SpeakerModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleModalClose = this.handleModalClose.bind(this);
    }

    _checkLinkProperties(link) {
        if (link === "" || link === undefined) {
            return {};
        } else {
            if (link.indexOf("linkedin") !== -1) {
                return {linkedIn: link};
            }

            return {link: link};
        }
    }

    handleModalClose(event) {
        if (event.key.toLowerCase() === "escape") {
            /* Close the modal */
            event.preventDefault();
            this.props.onClose();
        }
    }

    componentDidMount() {
        window.addEventListener("keydown", this.handleModalClose);
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.handleModalClose);
    }


    render() {
        const {data} = this.props;
        if (!data) return null;


        const name = data.fullName;
        const splitedName = name.split(" ");
        const title = `${data.title ? data.title : ""}${data.organization ? ", " + data.organization : ""}`;
        const biography = data.biography || '';

        let speakerLinkData = data.linkedIn ? data.linkedIn : data.link;
        const linkProperties = this._checkLinkProperties(speakerLinkData);
        return (
            <PopLayer>
                <div className='pubhub-agenda-speaker'>
                    <i className="close-btn" onClick={this.props.onClose}/>
                    <div className='container content'>
                        <div className='row justify-content-center'>
                            <div className='col-12 col-md-4 col-avatar'>
                                {!!data.photo ? <img src={data.photo} className="avatar"/> :
                                    <div className="avatar">
                                        {`${splitedName[0].charAt(0)}${splitedName[splitedName.length - 1].charAt(0)}`}
                                    </div>}
                            </div>
                            <div className='col-12 col-md-8'>
                                <div className='name'>{name}</div>
                                <div className='title'>{title}</div>
                                <div className="speaker-social">
                                    {!!data.twitter ?
                                        <a href={`https://twitter.com/${data.twitter}`}
                                           title={`${data.fullName} on twitter`}
                                           target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-twitter fa-2x fa-inverse social-icon"
                                               aria-hidden="true"></i>
                                        </a> : null}
                                    {linkProperties.hasOwnProperty("linkedIn") ?
                                        <a href={linkProperties["linkedIn"]} title={`${data.fullName} on LinkedIn`}
                                           target="_blank" rel="noopener noreferrer">
                                            <i className="fab fa-linkedin fa-2x fa-inverse social-icon"
                                               aria-hidden="true"></i>
                                        </a> : null}
                                    {linkProperties.hasOwnProperty("link") && linkProperties["link"] !== '' ?
                                        <a href={linkProperties["link"]} title={`${data.fullName}`}
                                           target="_blank" rel="noopener noreferrer">
                                            <i className="fa fa-link fa-2x fa-inverse social-icon"
                                               aria-hidden="true"></i> </a> : null}


                                </div>
                                <SafeHtmlPreview html={biography} className='biography' />
                            </div>
                        </div>
                    </div>
                </div>
            </PopLayer>
        );
    }
}
